"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateCodeChallenge = exports.createCodeVerifier = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _nanoid = require("nanoid");
var _base64Arraybuffer = require("base64-arraybuffer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; } /*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
// Server Side
const randomstring = require('randomstring');

// Globals
const isServer = typeof window === 'undefined';

/**
 * Creates Code Verifier use for PKCE auth flow.
 *
 * @returns {String} The 128 character length code verifier.
 */
const createCodeVerifier = () => {
  return isServer ? randomstring.generate(128) : (0, _nanoid.nanoid)(128);
};

/**
 * Creates Code Challenge based on Code Verifier
 *
 * @param {String} codeVerifier
 * @returns {String}
 */
exports.createCodeVerifier = createCodeVerifier;
const generateCodeChallenge = exports.generateCodeChallenge = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (codeVerifier) {
    let base64Digest;
    if (isServer) {
      yield Promise.resolve().then(() => _interopRequireWildcard(require('crypto'))).then(module => {
        const crypto = module.default;
        base64Digest = crypto.createHash('sha256').update(codeVerifier).digest('base64');
      });
    } else {
      const encoder = new TextEncoder();
      const data = encoder.encode(codeVerifier);
      const digest = yield window.crypto.subtle.digest('SHA-256', data);
      base64Digest = (0, _base64Arraybuffer.encode)(digest);
    }

    // @ts-ignore
    return base64Digest.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  });
  return function generateCodeChallenge(_x) {
    return _ref.apply(this, arguments);
  };
}();